export default __webpack_public_path__ + "static/media/home.27887ed9.png";